import { render, staticRenderFns } from "./partyGroupConfigAdd.vue?vue&type=template&id=f4aa41f4&scoped=true"
import script from "./partyGroupConfigAdd.vue?vue&type=script&lang=js"
export * from "./partyGroupConfigAdd.vue?vue&type=script&lang=js"
import style0 from "./partyGroupConfigAdd.vue?vue&type=style&index=0&id=f4aa41f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4aa41f4",
  null
  
)

export default component.exports